export default {
  props: {
    /**
     * Использовать асинхронную подгрузку картинки по мере скрола
     */
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      lazyImgSrcKey: '', // по какому ключу лежит src картинки
      srcImg: '',
      srcLoader: "data:image/svg+xml,%3Csvg width='34px' height='33px' viewBox='0 0 34 33' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-189.000000, -132.000000)'%3E%3Crect id='Rectangle' fill='%23B4B4B4' x='192' y='135' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23DADADA' x='208' y='135' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23E6E6E6' x='192' y='151' width='12' height='12'%3E%3C/rect%3E%3Crect id='Rectangle' fill='%23F6F6F6' x='208' y='151' width='12' height='12'%3E%3C/rect%3E%3C/g%3E%3C/g%3E%3C/svg%3E",
      timeoutIndex: null,
      isLazy: this.lazy
    }
  },
  created () {
    if (!this.isLazy) {
      this.formSrcImg()
    }
  },
  mounted () {
    if (this.isLazy) {
      window.addEventListener('resize', this.onScrollResize)
      window.addEventListener('scroll', this.onScrollResize)
      this.onScrollResize()
    }
  },
  beforeDestroy () {
    if (this.isLazy) {
      window.removeEventListener('resize', this.onScrollResize)
      window.removeEventListener('scroll', this.onScrollResize)
    }
  },
  methods: {

    formSrcImg () {
      this.srcImg = this.srcImage()
    },

    srcImage () {
      return this[this.lazyImgSrcKey] || ''
    },

    loadOriginalImage () {
      const src = this.srcImage()

      if (!src) {
        return
      }

      const image = new Image()

      image.onload = () => {
        this.srcImg = src
        this.emitLazyEvent()
      }

      image.src = src
    },

    emitLazyEvent () {

      const emitLazyEvent = () => {
        this.$emit('lazyLoaded')

        if (this.$globalEvents) {
          this.$globalEvents.$emit('wResize')
        }
      }

      this.$nextTick(() => {
        setTimeout(emitLazyEvent, 100)
        setTimeout(emitLazyEvent, 250)
      })
    },

    onScrollResize () {

      if (this.srcImg || this.timeoutIndex !== null) {
        return
      }

      const height = window.innerHeight
      const offsetHeight = 20 // дополнительный отступ (чтоб картинка грузилась чуть раньше)
      const { img } = this.$refs

      if (!img) {
        return
      }

      const bounding = img.getBoundingClientRect()

      const isHidden = bounding => {
        const props = ['bottom', 'height', 'left', 'right', 'top', 'width', 'x', 'y']
        let hidden = true

        for (const i in props) {
          // eslint-disable-next-line no-prototype-builtins
          if (props.hasOwnProperty(i)) {
            const prop = props[i]

            if (bounding[prop] !== 0) {
              hidden = false
            }
          }
        }

        return hidden
      }

      if (bounding.top < height + offsetHeight && !isHidden(bounding)) {
        this.timeoutIndex = true

        this.loadOriginalImage()

        return
      }

      this.timeoutIndex = setTimeout(() => {
        this.timeoutIndex = null
      }, 100)
    }
  },
  watch: {
    isLazy (value) {
      if (!value) {
        this.formSrcImg()
      }
    }
  }
}
